import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  Link,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useSerialStore } from '../stores/serialStore';

interface AboutModalProps {
  open: boolean;
  onClose: () => void;
}

export const AboutModal: React.FC<AboutModalProps> = ({ open, onClose }) => {
  const version = __APP_VERSION__;
  const isConnected = useSerialStore((state) => state.isConnected);

  const handleExternalLink = (url: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    const electronAPI = (window as any).electronAPI;
    if (electronAPI?.isElectron) {
      electronAPI.openExternal(url);
    } else {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      disablePortal
      sx={{
        position: 'absolute',
        height: '100%',
        width: '100%',
      }}
      BackdropProps={{
        sx: {
          position: 'absolute',
          height: '100%',
          width: '100%',
        }
      }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
        About EasyPCR
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3,
            py: 2,
          }}
        >
          {/* Logo/Icon */}
          <Box
            component="img"
            src="./favicon.png"
            alt="EasyPCR"
            sx={{ height: 120, width: 'auto' }}
          />

          {/* Application Name */}
          <Typography variant="h4" component="h2" sx={{ fontWeight: 600 }}>
            EasyPCR
          </Typography>

          {/* Homepage Link */}
          <Link
            href="https://easypcr.io"
            onClick={handleExternalLink('https://easypcr.io')}
            sx={{
              fontSize: '1rem',
              fontWeight: 500,
              textDecoration: 'none',
              cursor: 'pointer',
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
          >
            https://easypcr.io
          </Link>

          {/* Version */}
          <Typography variant="body1" color="text.secondary">
            Version: {version}
          </Typography>

          {/* Device Status */}
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', mt: 2 }}>
            Device: {isConnected ? 'Connected' : 'Disconnected'}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
